module.exports = __webpack_public_path__ + "606ef2328cd2d990ed70a9df06799f7f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/heros/api-employee.png
// module id = 629
// module chunks = 0